var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1429 5.97337C16.0575 5.65319 15.884 5.31204 15.7557 5.01334C14.2199 1.32267 10.8645 0 8.15507 0C4.52806 0 0.53333 2.43207 0 7.44513V8.46933C0 8.51207 0.014731 8.89603 0.0356557 9.08809C0.334628 11.4772 2.21981 14.0163 3.62774 16.4054C5.14246 18.9651 6.71422 21.4831 8.27141 24C9.2316 22.3575 10.1883 20.6934 11.1267 19.0934C11.3824 18.6238 11.6792 18.1546 11.9352 17.7064C12.1059 17.408 12.4319 17.1096 12.5808 16.8319C14.0955 14.0587 16.5335 11.2641 16.5335 8.51201V7.38141C16.5336 7.08305 16.1637 6.03771 16.1429 5.97337ZM8.22147 11.1148C7.15531 11.1148 5.98832 10.5817 5.41231 9.10946C5.32649 8.8751 5.33341 8.40544 5.33341 8.36242V7.70108C5.33341 5.82422 6.92704 4.97071 8.31342 4.97071C10.0202 4.97071 11.3403 6.33623 11.3403 8.04302C11.3403 9.74975 9.92826 11.1148 8.22147 11.1148Z",
    fill: "#F652F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/place.d549f36b.svg";
export { ForwardRef as ReactComponent };